import { useState, useEffect } from 'react';
import { useUrlParams } from '../utils/url';
import { apiGet } from '../utils/api';

export interface SlotType {
  value: string;
  label: string;
  ehrProvider: 'cerner' | 'epic';
  isSnomed?: boolean; // Only used for Cerner slot types
}

export const useSlotTypes = () => {
  const params = useUrlParams();
  const org_id = params.org_id;
  const [ slotTypes, setSlotTypes ] = useState<SlotType[]>([]);
  const [ loading, setLoading ] = useState<boolean>(true);
  const [ error, setError ] = useState<string | null>(null);

  useEffect(() => {
    const fetchSlotTypes = async () => {

      if (!org_id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await apiGet(`/api/${org_id}/slot-types`);
        if (!response.ok) throw new Error('Failed to fetch slot types');

        const data = await response.json();
        setSlotTypes(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch slot types');
      } finally {
        setLoading(false);
      }
    };

    fetchSlotTypes();
  }, [ org_id ]);

  return { slotTypes, loading, error };
};
